/**
 * 新增修改客户信息
 */
import React, { Component } from 'react';
import moment from 'moment';
import { Modal, Form, Input, DatePicker} from 'antd';
import DictSelect from '../../ui/DictSelect';

import http from '../../../axios/http';
import messager from '../../ui/messager';

const fields = [{
    "text": "客户",
    "field": "name",
    "client": true,
    "disabled": true
}, {
    "text": "登记日期",
    "field": "interactionDate",
    "date": true,
    rules: [
        { required: true, message: '登记日期不能为空!' },
    ]
}, {
    "text": "拜访记录",
    "field": "remarks",
    "textarea": true,
    rules: [
        { required: true, message: '拜访记录不能为空!' },
    ]
}];


class ClientInteractionEditForm extends Component {

    state = {
    }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["clientId"] = this.props.editData.id;
            if (values["interactionDate"] != null) {
                values["interactionDate"] = values["interactionDate"].format("YYYY-MM-DD");
            } 
            http.post({
                url: '/market/clientInteraction/save',
                data: values,
                success: (res) => {
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    if (this.props.onSuccessCallback) {
                        //返回交往记录id，设置到values中
                        values["id"] = res;
                        this.props.onSuccessCallback(values);
                    }
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                    <Form.Item key={i} label={item.text + "："}>
                        {
                            getFieldDecorator(item.field, {
                                rules: item.rules,
                                initialValue: item.date ? (editData[item.field] ? new moment(editData[item.field]) : new moment()) : editData[item.field],
                                valuePropName: item.radio ? 'checked' : 'value'
                            })(
                                item.date ? <DatePicker style={{ width: '100%' }} />
                                                : item.select ? <DictSelect category={item.category} />
                                                    : item.textarea ? <Input.TextArea disabled={item.disabled === true} /> 
                                                            : <Input disabled={item.disabled} />
                            )
                        }
                    </Form.Item>
                );
            dom.push(itemDom);
        }
        return dom;
    };

    afterClose = () => {
        this.props.form.resetFields();
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="拜访登记"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={this.afterClose}
            >
                <Form layout="vertical" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                    {this.createDom(fields)}
                </Form>
            </Modal>
        );
    }
}

const ClientInteractionEdit = Form.create()(ClientInteractionEditForm);

export default ClientInteractionEdit;